module.exports = __webpack_public_path__ + "img/because.be5030ca.webp";